import type { RuntimeDataServiceId } from './contracts';
import type { ActiveDataBinding, BindingId } from './types';

export function createBindingId(
    binding: Pick<ActiveDataBinding, 'serviceId' | 'linkKey'>
): BindingId;
export function createBindingId(serviceId: RuntimeDataServiceId, linkKey: string): BindingId;
export function createBindingId(
    bindingOrServiceId: Pick<ActiveDataBinding, 'serviceId' | 'linkKey'> | RuntimeDataServiceId,
    maybeLinkKey?: string
): BindingId {
    if (typeof bindingOrServiceId === 'string') {
        if (typeof maybeLinkKey !== 'string' || maybeLinkKey.length === 0) {
            throw new Error('Expected runtime binding link key when creating binding ID.');
        }

        return `${bindingOrServiceId}.${maybeLinkKey}`;
    }

    return `${bindingOrServiceId.serviceId}.${bindingOrServiceId.linkKey}`;
}
